module.exports = __webpack_public_path__ + "img/partner-4.c6457330.png";